/**
* Import Languages
*
* Auto Translate:
* $ i18n-auto-translation -d ./locales/test -t ir --apiProvider deep-rapid --key 8a896f5041mshb6bb705a734ea73p13e8eajsnbeaf5bf3c1c1

*/
import global_en from './global/en'
import customusb_en from './customusb/en'
import gildedbox_en from './gildedbox/en'

const deepMerge = (obj1, obj2) => {
  const result = { ...obj1 }

  for (const key in obj2) {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      if (typeof obj2[key] === 'object' && !Array.isArray(obj2[key])) {
        result[key] = deepMerge(result[key] || {}, obj2[key])
      } else if (typeof obj2[key] !== 'undefined') {
        result[key] = obj2[key]
      }
    }
  }
  return result
}

export default {
  en_customusb: deepMerge(global_en, customusb_en),
  en_gildedbox: deepMerge(global_en, gildedbox_en)
}
